import { render, staticRenderFns } from "./ShippingStatuses.vue?vue&type=template&id=3c1cdc39"
import script from "./ShippingStatuses.vue?vue&type=script&lang=js"
export * from "./ShippingStatuses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports